/**
 * 旅行回忆系统 - 权限路由组件
 * 检查用户是否有travelMemories模块权限
 */

import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { hasTravelMemoriesPermission } from '../utils/travelMemoriesAuth';

const TravelMemoriesRoute = ({ children }) => {
  const [hasPermission, setHasPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const permission = await hasTravelMemoriesPermission();
        setHasPermission(permission);
      } catch (error) {
        console.error('权限检查失败:', error);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>加载中...</div>
      </div>
    );
  }

  if (!hasPermission) {
    return (
      <Navigate 
        to="/" 
        replace 
        state={{ 
          message: '您没有访问旅行回忆系统的权限，请联系管理员分配权限' 
        }} 
      />
    );
  }

  return children;
};

export default TravelMemoriesRoute;
